// @ts-ignore
import type * as SchemaTypes from '../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ComponentRoundedImageFragmentDoc } from './component/ComponentRoundedImage.fragment.generated';
import { ComponentRoundedImageContentFragmentDoc } from './component/ComponentRoundedImageContent.fragment.generated';
import { ComponentContentFragmentDoc } from './component/ComponentContent.fragment.generated';
import { ComponentCardFragmentDoc } from './component/CardComponent.fragment.generated';
import { ComponentTextOverImageFragmentDoc } from './component/ComponentTextOverImage.fragment.generated';
import { ComponentCustomProductCarouselFragmentDoc } from './component/ComponentCustomProductCarousel.fragment.generated';
import { ComponentCatalogueProductCarouselFragmentDoc } from './component/ComponentCatalogueProductCarousel.fragment.generated';
import { ComponentReviewCarouselFragmentDoc } from './component/ComponentReviewCarousel.fragment.generated';
import { ComponentMainCoverFragmentDoc } from './component/ComponentMainCover.fragment.generated';
import { ComponentVideoFragmentDoc } from './component/ComponentVideo.fragment.generated';
import { ComponentVideoWithContentFragmentDoc } from './component/ComponentVideoWithContent.fragment.generated';
import { ComponentInstagramPostsFragmentDoc } from './component/ComponentInstagramPosts.fragment.generated';
import { ComponentLogosFragmentDoc } from './component/ComponentLogos.fragment.generated';
import { ComponentLogosCarouselFragmentDoc } from './component/ComponentLogosCarousel.fragment.generated';
import { ComponentTextWithImageFragmentDoc } from './component/ComponentTextWithImage.fragment.generated';
import { ComponentGalleryCarouselFragmentDoc } from './component/ComponentGalleryCarousel.fragment.generated';
import { ComponentCardCarouselFragmentDoc } from './component/carousel/card/ComponentCardCarousel.fragment.generated';
import { ComponentFullWidthImageFragmentDoc } from './component/ComponentFullWidthImage.fragment.generated';
import { ComponentSideBySideImagesFragmentDoc } from './component/ComponentSideBySideImages.fragment.generated';
import { ComponentArticlePreviewsFragmentDoc } from './component/ComponentArticlePreviews.fragment.generated';
import { ComponentInstagramWithContentFragmentDoc } from './component/ComponentInstagramWithContent.fragment.generated';
import { ComponentBannerTitleFragmentDoc } from './component/ComponentBannerTitle.fragment.generated';
import { ComponentQuoteFragmentDoc } from './component/ComponentQuote.fragment.generated';
import { ComponentBannerSkinnyFragmentDoc } from './component/ComponentBannerSkinny.fragment.generated';
import { ComponentGlobalSpacerFragmentDoc } from './component/ComponentGlobalSpacer.fragment.generated';
import { ComponentTextWithImageCarouselFragmentDoc } from './component/ComponentTextWithImageCarousel.fragment.generated';
import { ComponentContentWithGalleryFragmentDoc } from './component/ComponentContentWithGallery.fragment.generated';
import { ComponentIconCarouselFragmentDoc } from './component/ComponentIconCarousel.fragment.generated';
import { ComponentTextCarouselFragmentDoc } from './component/ComponentTextCarousel.fragment.generated';
import { ComponentFaqFragmentDoc } from './component/ComponentFaq.fragment.generated';
import { ComponentContentTwoColumnsFragmentDoc } from './component/ComponentContentTwoColumns.fragment.generated';
import { ComponentTableFragmentDoc } from './component/ComponentTable.fragment.generated';
import { ComponentArticleGridFragmentDoc } from './component/ComponentArticleGrid.fragment.generated';
import { ComponentOnThisPageFragmentDoc } from './component/ComponentOnThisPage.fragment.generated';
import { ComponentGalleryWithEnquiryFragmentDoc } from './component/gallery-with-enquiry/componentGalleryWithEnquiry.generated';
import { ComponentSquareBoxesFragmentDoc } from './component/square-boxes/ComponentSquareBoxes.fragment.generated';
import { ComponentShopWithConfidenceFragmentDoc } from './component/ComponentShopWithConfidence.generated';
export const ComponentFragmentDoc = gql`
    fragment component on Component {
  __typename
  ...componentRoundedImage
  ...componentRoundedImageContent
  ...componentContent
  ...componentCard
  ...componentTextOverImage
  ...componentRoundedImage
  ...componentCustomProductCarousel
  ...componentCatalogueProductCarousel
  ...componentReviewCarousel
  ...componentMainCover
  ...componentVideo
  ...componentVideoWithContent
  ...componentInstagramPosts
  ...componentLogos
  ...componentLogosCarousel
  ...componentTextWithImage
  ...componentGalleryCarousel
  ...componentCardCarousel
  ...componentFullWidthImage
  ...componentSideBySideImages
  ...componentArticlePreviews
  ...componentInstagramWithContent
  ...componentBannerTitle
  ...componentQuote
  ...componentBannerSkinny
  ...componentGlobalSpacer
  ...componentTextWithImageCarousel
  ...componentContentWithGallery
  ...componentIconCarousel
  ...componentTextCarousel
  ...componentFaq
  ...componentContentTwoColumns
  ...componentTable
  ...componentArticleGrid
  ...componentOnThisPage
  ...componentGalleryWithEnquiry
  ...componentSquareBoxes
  ...componentShopWithConfidence
}
    ${ComponentRoundedImageFragmentDoc}
${ComponentRoundedImageContentFragmentDoc}
${ComponentContentFragmentDoc}
${ComponentCardFragmentDoc}
${ComponentTextOverImageFragmentDoc}
${ComponentCustomProductCarouselFragmentDoc}
${ComponentCatalogueProductCarouselFragmentDoc}
${ComponentReviewCarouselFragmentDoc}
${ComponentMainCoverFragmentDoc}
${ComponentVideoFragmentDoc}
${ComponentVideoWithContentFragmentDoc}
${ComponentInstagramPostsFragmentDoc}
${ComponentLogosFragmentDoc}
${ComponentLogosCarouselFragmentDoc}
${ComponentTextWithImageFragmentDoc}
${ComponentGalleryCarouselFragmentDoc}
${ComponentCardCarouselFragmentDoc}
${ComponentFullWidthImageFragmentDoc}
${ComponentSideBySideImagesFragmentDoc}
${ComponentArticlePreviewsFragmentDoc}
${ComponentInstagramWithContentFragmentDoc}
${ComponentBannerTitleFragmentDoc}
${ComponentQuoteFragmentDoc}
${ComponentBannerSkinnyFragmentDoc}
${ComponentGlobalSpacerFragmentDoc}
${ComponentTextWithImageCarouselFragmentDoc}
${ComponentContentWithGalleryFragmentDoc}
${ComponentIconCarouselFragmentDoc}
${ComponentTextCarouselFragmentDoc}
${ComponentFaqFragmentDoc}
${ComponentContentTwoColumnsFragmentDoc}
${ComponentTableFragmentDoc}
${ComponentArticleGridFragmentDoc}
${ComponentOnThisPageFragmentDoc}
${ComponentGalleryWithEnquiryFragmentDoc}
${ComponentSquareBoxesFragmentDoc}
${ComponentShopWithConfidenceFragmentDoc}`;